import React, { useMemo, useRef, useState } from 'react';
import JoditEditor from 'jodit-react';
import { Box, Typography } from '@mui/material';

type IProps = {
  placeholder: string;
  content: string;
  onChange: (a: string) => void;
};
type config = {
  placeholder: string;
};
function CustomRichText({ placeholder, content, onChange }: IProps) {
  const editor = useRef(null);
  return (
    <Box sx={{ marginTop: 3, marginBottom: 3 }}>
      <Typography variant='body2'>{placeholder}</Typography>
      <JoditEditor
        ref={editor}
        value={content}
        config={{
          placeholder,
        }}
        onBlur={(newContent: string) => onChange(newContent)} // preferred to use only this option to update the content for performance reasons
        onChange={(newContent: string) => {}}
      />
    </Box>
  );
}

export default CustomRichText;
